/**
 * Deep-link scrolling for Apps sections.
 *
 * App blocks (e.g. Yotpo reviews) lazy-load their content after the browser's
 * one-shot native anchor scroll, so a `/products/x#reviews` link lands in the
 * wrong place or not at all. This re-scrolls to the hash target while the async
 * content settles, and bails out the moment the user scrolls themselves.
 */
(function () {
  function init() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var target = document.getElementById(decodeURIComponent(hash.slice(1)));
    // Only handle anchors that live inside an Apps section.
    if (!target || !target.closest('.section-apps')) return;

    var interrupted = false;
    function stop() { interrupted = true; }
    window.addEventListener('wheel', stop, { passive: true, once: true });
    window.addEventListener('touchmove', stop, { passive: true, once: true });
    window.addEventListener('keydown', function (e) {
      if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].indexOf(e.key) > -1) {
        stop();
      }
    }, { once: true });

    function jump() {
      if (interrupted) return;
      target.scrollIntoView();
    }

    jump();

    // Re-scroll as async content (e.g. Yotpo reviews) loads and shifts layout.
    if (typeof ResizeObserver === 'function') {
      var observer = new ResizeObserver(jump);
      observer.observe(document.body);
      setTimeout(function () { observer.disconnect(); }, 4000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
